import { render } from "./EiScaleComparisonTable.vue?vue&type=template&id=2d735c3e&scoped=true"
import script from "./EiScaleComparisonTable.vue?vue&type=script&lang=js"
export * from "./EiScaleComparisonTable.vue?vue&type=script&lang=js"

import "./EiScaleComparisonTable.vue?vue&type=style&index=0&id=2d735c3e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d735c3e"]])

export default __exports__